import { TextInput as NativeTextInput } from 'react-native';
import { animated } from '../../styling';

const AnimatedTextInput = animated(NativeTextInput);

export { AnimatedTextInput as BaseInput };
